export default __webpack_public_path__ + "static/media/access_white.d3ae42be.svg";